exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".translations-list-component .focus-editable{line-height:1.8}.translations-list-component .focus-editable:not(:focus){border-color:transparent}.translations-list-component .fixed-50{width:50%}.translations-list-component th.bt-0{border-top:none!important}.translations-list-component .translation-edited,.translations-list-component .translation-edited:focus{background-color:#fdf9ee}", ""]);

// exports
